module.exports = __webpack_public_path__ + "static/media/gill_voyager_dry_bag.c4ae57c4.jpg";